<div class="address-container" *ngIf="addressArray.length > 0">
  <app-address
    (click)="select(i)"
    (onDelete)="delete(i)"
    [isSelected]="isSelected(address)"
    [address]="address"
    *ngFor="let address of addressArray; index as i"
  ></app-address>
</div>
<div
  *ngIf="contentLoaded && addressArray.length === 0"
  style="text-align: center"
>
  <h3>هیچ آدرسی موجود نیست</h3>
</div>

<div
  fxLayout="row"
  fxLayoutAlign="center center"
  *ngIf="!contentLoaded"
  style="padding: 50px"
>
  <mat-spinner></mat-spinner>
</div>
